<template>
	<div class="withdraw">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onexport()">导出提现列表</el-button>
			<el-button type="primary" size="small" @click="onadd()">提现</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.state" placeholder="状态">
							<el-option label="状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.withdraw_state"
								:key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-date-picker v-model="formfilter.mydate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="trade_no" fixed="left" label="流水号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="money" label="金额" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="nickname" label="提取人" align="center" header-align="center">
					</el-table-column>
					<el-table-column label="财务账号" align="center" header-align="center">
						<template slot-scope="scope">
							<div>
								<p>{{scope.row.bank_arr.ctype_str}}</p>
								<p>{{scope.row.bank_arr.account}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="create_time_str" fixed="right" label="创建时间" align="center"
						header-align="center">
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
		<el-dialog title="提现" :visible.sync="show" width="600px" :before-close="onclose">
			<div class="forms" v-if="show">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
					<el-form-item label="收款账号" prop="bank_id" class="myformitem">
						<el-select v-model="ruleForm.bank_id" placeholder="请选择收款账号">
							<el-option :label="v.ctype_str+'-'+v.account" :value="v.id" v-for="(v,k) in cwzh" :key="k">
								{{v.ctype_str}}-{{v.account}}
							</el-option>
						</el-select>
						<i class="i el-icon-circle-plus-outline" @click="onadd1()"></i>
						<p v-if="tshow" class="myjg">当选择了“对公银行账号”转账时，后续必须提供开票！</p>
					</el-form-item>
					<el-form-item label="金额" prop="money">
						<el-input v-model="ruleForm.money" placeholder="请输入金额"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
		</el-dialog>
		<add ref="add" :type="1" @upadd="oncwzh()"></add>
	</div>
</template>

<script>
	export default {
		name: 'Withdraw',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				show: false,
				filtershow: true,

				formfilter: {
					state: "",
					mydate: [],
					btime: "",
					etime: "",
				},

				ruleForm: {
					bank_id: "",
					money: ""
				},

				rules: {
					bank_id: [{
						required: true,
						message: '请选择收款账号',
						trigger: 'change'
					}],

					money: [{
						required: true,
						message: '请输入金额',
						trigger: 'blur'
					}],
				},

				cwzh: [],

				tshow: false
			}
		},

		inject: ['appdata'],

		mounted() {
			this.onlist();
			this.oncwzh();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		watch: {
			'ruleForm.bank_id': {
				handler(newQuery, oldQuery) {
					this.tshow = false;
					if (newQuery && this.cwzh.length > 0) {
						this.cwzh.forEach((v, k) => {
							if (v.id == newQuery) {
								if (v.ctype == 1) {
									this.tshow = true;
								}
							}
						})
					}
				},
				deep: true, // 确保对象内部属性的变化也能被检测到
				immediate: true, // 组件创建时立即执行一次handler
			}
		},

		methods: {
			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			onfilter() {
				this.page = 1;
				this.onlist();
			},

			onreset() {
				this.formfilter = {
					state: "",
					mydate: [],
					btime: "",
					etime: "",
				};
				this.page = 1;
				this.onlist();
			},

			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/user/user_withdraw_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			oncwzh() {
				var obj = {};
				obj.page = 1;
				obj.limit = 10000;
				this.$axios.post('api/user/user_bank_list', obj).then(res => {
					if (res.data.code == 0) {
						this.cwzh = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onadd() {
				this.show = true;
			},

			onclose() {
				this.show = false;
				this.ruleForm = {
					bank_id: "",
					money: ""
				};
			},

			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						this.$axios.post('api/user/user_withdraw', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},
			
			onexport() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				this.$axios.post('/api/user/user_withdraw_export', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('请前往任务中心-导出列表下载');
						this.$parent.oncount();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onadd1() {
				this.$refs.add.show2 = true;
			}
		}
	}
</script>

<style scoped lang="less">
	.withdraw {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 104px);
	}

	.tablediv {
		height: 100%;
	}

	/deep/.forms .el-select {
		width: 400px;
	}

	/deep/.forms .el-input {
		width: 400px;
	}

	.filterty .el-date-editor {
		width: 250px;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/withdraw.vue